import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { tap, catchError, of } from 'rxjs';
import { LoadDistributors, SetSelectedDistributor, ClearDistributorData } from './distributor.actions';
import { DistributorApiService } from '../service/distributor-api.service';

export interface DistributorStateModel {
  distributors: string[] | null;
  selectedDistributor: string | null;
  loading: boolean;
  error: string | null;
}

const defaults: DistributorStateModel = {
  distributors: null,
  selectedDistributor: null,
  loading: false,
  error: null,
};

@State<DistributorStateModel>({
  name: 'distributor',
  defaults,
})
@Injectable()
export class DistributorState {
  constructor(private distributorApiService: DistributorApiService) {}

  @Action(LoadDistributors)
  loadDistributors(ctx: StateContext<DistributorStateModel>) {
    ctx.patchState({ loading: true, error: null });
    
    return this.distributorApiService.getList().pipe(
      tap(distributors => {
        ctx.patchState({ distributors, loading: false, error: null });
      }),
      catchError((error) => {
        ctx.patchState({
          error: 'Failed to load distributors. Please try again later.',
          loading: false,
          distributors: []
        });
        console.error('Failed to load distributors:', error);
        return of([]);
      })
    );
  }

  @Action(ClearDistributorData)
  clearData(ctx: StateContext<DistributorStateModel>) {
    ctx.setState(defaults);
  }

  @Action(SetSelectedDistributor)
  setSelectedDistributor(ctx: StateContext<DistributorStateModel>, action: SetSelectedDistributor) {
    ctx.patchState({ selectedDistributor: action.distributor });
  }
}
